import { render, staticRenderFns } from "./AdminPannel.vue?vue&type=template&id=1ae7d044&"
import script from "./AdminPannel.vue?vue&type=script&lang=js&"
export * from "./AdminPannel.vue?vue&type=script&lang=js&"
import style0 from "./AdminPannel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports